<script setup lang="ts">
// "The home card" — a playing card carrying the Michigan mitten. Ported from
// logos.jsx, but using the high-fidelity MichiganMitten in place of the kit blob.
import { computed } from 'vue'
import { BK } from '../tokens'
import MichiganMitten from '../MichiganMitten.vue'

const props = withDefaults(
  defineProps<{
    w?: number
    border?: string
    mitten?: string
    pip?: string
    pipColor?: string
    tilt?: number
  }>(),
  { w: 92, border: BK.barn, mitten: BK.pine, pip: '♦', pipColor: BK.barn, tilt: 0 },
)

const cardStyle = computed(() => ({
  width: `${props.w}px`,
  height: `${props.w * 1.4}px`,
  borderRadius: `${props.w * 0.1}px`,
  background: '#f7f1e3',
  border: `2px solid ${props.border}`,
  boxShadow: '0 2px 0 rgba(43,37,25,.16), 0 9px 20px rgba(43,37,25,.22)',
  transform: `rotate(${props.tilt}deg)`,
}))
const idxStyle = computed(() => ({
  lineHeight: '0.82',
  textAlign: 'center' as const,
  color: props.pipColor,
  fontFamily: '"Zilla Slab", serif',
}))
const miSize = computed(() => `${props.w * 0.19}px`)
const pipSize = computed(() => `${props.w * 0.16}px`)
</script>

<template>
  <div class="mi-card" :style="cardStyle">
    <div class="mi-card__idx mi-card__idx--tl" :style="idxStyle">
      <div :style="{ fontSize: miSize, fontWeight: 700 }">MI</div>
      <div :style="{ fontSize: pipSize }">{{ pip }}</div>
    </div>
    <div class="mi-card__idx mi-card__idx--br" :style="idxStyle">
      <div :style="{ fontSize: miSize, fontWeight: 700 }">MI</div>
      <div :style="{ fontSize: pipSize }">{{ pip }}</div>
    </div>
    <div class="mi-card__center">
      <MichiganMitten :size="w * 0.42" :fill="mitten" />
    </div>
  </div>
</template>

<style scoped>
.mi-card {
  position: relative;
  flex-shrink: 0;
}
.mi-card__idx {
  position: absolute;
}
.mi-card__idx--tl {
  top: 8%;
  left: 10%;
}
.mi-card__idx--br {
  bottom: 8%;
  right: 10%;
  transform: rotate(180deg);
}
.mi-card__center {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
}
</style>
